const styles = () => ({
    containerForm: {
        minWidth: '600px',
        maxWidth: '800px',
    },
    radio: {
        marginBottom: '20px',
        paddingBottom: '20px',
        borderBottom: '1px solid #ccc',
    },
    noBorder: {
        border: 'none',
    },
    centerProgress: {
        textAlign: 'center',
        margin: '10px 0',
    },
    requestResult: {
        fontSize: '14px',
    },
    noResults: {
        textAlign: 'center',
        margin: '10px 0',
        fontSize: '16px',
        color: '#666',
    },
});

export default styles;
